import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/partner/menusUser/filter'; // Importing Filter component
import Table from 'views/partner/menusUser/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * MenuView class extending JetView to create a menu interface.
 */
export default class MenuView extends JetView {
    /**
     * Configures the UI components of the MenuView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Theme configuration
        const toolbar = {
            view: 'toolbar', // Toolbar component
            id: 'toolbar', // Unique identifier for the toolbar
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                {},
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export', // Name of the select
                    id: 'Export', // Unique identifier for the select
                    width: 120, // Width of the select
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        // Options for export format
                        { id: '1', value: 'Excel' }, // Excel option
                        { id: '2', value: 'PDF' }, // PDF option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for change event
                            if (value == 1) {
                                // If Excel is selected
                                var table = $$('datatable'); // Get the datatable instance
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        // Check for export type
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Menu',
                                    ignore: {
                                        detailTittle: true, // Ignore detail title in export
                                        ActionTittle: true, // Ignore action title in export
                                    },
                                });
                            } else {
                                if (value == 2) {
                                    // If PDF is selected
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Menu',
                                        autowidth: true, // Automatically adjust width
                                        ignore: {
                                            detailTittle: true, // Ignore detail title in export
                                            ActionTittle: true, // Ignore action title in export
                                        },
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset the export select value
                        },
                    },
                },
            ],
        };
        const left = {
            css: 'int-left', // CSS class for left section
            rows: [
                {
                    view: 'toolbar', // Toolbar for user menus
                    css: theme, // Apply theme CSS
                    elements: [
                        { view: 'label', label: _('Menús Usuario') }, // Label for user menus
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            id: 'button-search', // Unique identifier for search button
                            cols: [
                                {
                                    view: 'icon', // Icon for search
                                    icon: 'wxi-search', // Search icon
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => {
                                        // Click event to show filter popup
                                        $$('filterPopup').show();
                                    },
                                },
                            ],
                        },
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            cols: [
                                {
                                    view: 'icon', // Icon for close action
                                    icon: 'wxi-close', // Close icon
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => this.show('/top/dashboard'), // Navigate to dashboard on click
                                },
                            ],
                        },
                    ],
                },
                Filter, // Include Filter component
                Table, // Include Table component
                toolbar, // Include toolbar
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            id: 'a5', // Unique identifier for the form
            type: 'clean', // Clean type for the form
            view: 'form', // Form view
            scroll: 'y', // Enable vertical scrolling
            rows: [
                {
                    responsive: 'a5', // Responsive design for the form
                    type: 'wide',
                    cols: [left], // Include left section
                },
            ],
        };
    }

    /**
     * Initializes the MenuView and sets up responsive behavior.
     * @param {Object} grid - The grid instance.
     */
    init(grid) {
        webix.ready(function () {
            // Execute when Webix is ready
            if (screen.width < 500 || screen.height < 500) {
                // Check screen size
                $$('toolbar').hide(); // Hide toolbar on small screens
            }
            if (screen.width > 500 && screen.height > 500) {
                // Check screen size
                $$('button-search').hide(); // Hide search button on larger screens
            }
            $.fn.scrollBottom = function () {
                // jQuery function to calculate scroll bottom
                return $(document).height() - this.scrollTop() - this.height();
            };
        });
    }
}

// FILE DOCUMENTED
